'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var ROOT = 'mdc-typography';
exports.default = ROOT;


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-mdc-web/lib/Typography/constants.js
// module id = 119
// module chunks = 0